import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, watch } from "vue";
import Keyboard from "../keyboard";
export default {
  __name: 'index',
  emits: ['success'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emit = __emit;
    const show = ref(false);
    const pwd = ref('');
    const onInput = value => {
      if (pwd.value.length < 6) {
        pwd.value += String(value);
      }
      if (pwd.value.length >= 6) {
        show.value = false;
        emit('success', pwd.value);
        pwd.value = '';
      }
    };
    const onDelete = () => {
      pwd.value = pwd.value.slice(0, -1);
    };
    watch(show, (newValue, oldValue) => {
      if (!newValue) {
        pwd.value = '';
      }
    });
    __expose({
      setShow(e) {
        show.value = e;
      }
    });
    return (_ctx, _cache) => {
      const _component_van_password_input = _resolveComponent("van-password-input");
      const _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createBlock(_component_van_popup, {
        show: show.value,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => show.value = $event),
        position: "bottom",
        closeable: "",
        class: "pwdpopup"
      }, {
        default: _withCtx(() => [_cache[1] || (_cache[1] = _createElementVNode("div", {
          class: "hint"
        }, "请输入支付密码", -1)), _createVNode(_component_van_password_input, {
          value: pwd.value,
          focused: true
        }, null, 8, ["value"]), _createVNode(_unref(Keyboard), {
          onInput: onInput,
          onDelete: onDelete
        })]),
        _: 1
      }, 8, ["show"]);
    };
  }
};